import { NotiButtonState } from '@/constants';
import { UNKNOWN_CARRIER_ID } from '@/modules/pmt/constants';
import { EventPhaseKey, type INotiButtonStateByParcel, type IShipment } from '@/modules/pmt/interfaces';

type TIsNotiAllowed = (params: {
  shipment?: IShipment;
  notiButtonState?: NotiButtonState;
  notiButtonStateByParcel: INotiButtonStateByParcel;
}) => boolean;

export const isNotiAllowed: TIsNotiAllowed = ({ shipment, notiButtonState, notiButtonStateByParcel }) => {
  if (!shipment?.data) return false;
  const { isEmailSyncShipment, isSMEShipment } = shipment.data;

  if (isEmailSyncShipment || isSMEShipment) return false;

  // https://www.pivotaltracker.com/n/projects/2649247/stories/186655454
  const latestEvent = shipment.data.parcel?.lastEvent;
  if (
    latestEvent?.isFinalEvent &&
    (latestEvent.phaseKey === EventPhaseKey.Delivery || latestEvent.phaseKey === EventPhaseKey.ReturnToSender)
  ) {
    return false;
  }

  const parcelId = shipment.data.parcel?.parcelId;
  const carrierId = shipment.data.carrierId ?? UNKNOWN_CARRIER_ID;

  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  if (!notiButtonStateByParcel[parcelId]?.[carrierId] || notiButtonState === NotiButtonState.None) {
    return false;
  }

  return true;
};
